import { Menu } from "antd";
import {
  InboxOutlined,
  HomeOutlined,
  // UserOutlined,
  BarChartOutlined,
  EnvironmentOutlined,
  UserOutlined,
  BellOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

export default function MenuSider() {
  const navigate = useNavigate();
  const location = useLocation();

  const menuFuntions = (key) => {
    navigate(key);
  };

  const selectedKey = location.pathname === "/" ? "/" : `/${location.pathname.split("/")[1]}`;

  const menuItems = [
    {
      key: "/",
      icon: <HomeOutlined />,
      label: "Inicio",
    },
    {
      key: "/eventos",
      icon: <InboxOutlined />,
      label: "Eventos",
    },
    {
      key: "/dashboards",
      icon: <BarChartOutlined />,
      label: "Dashboards",
    },
    {
      key: "/usuarios",
      icon: <UserOutlined />,
      label: "Usuarios",
    },
    {
      key: "/ubicaciones",
      icon: <EnvironmentOutlined />,
      label: "Ubicaciones",
    },
    {
      key: "/recordatorios",
      icon: <BellOutlined />,
      label: "Recordatorios",
    },
  ];

  return (
    <Menu
      theme="light"
      mode="inline"
      items={menuItems}
      selectedKeys={[selectedKey]}
      onClick={(e) => menuFuntions(e.key)}
    />
  );
}
